// extracted by mini-css-extract-plugin
export var attachment = "_lq-a";
export var emailContainer = "_lq-4";
export var emailContentPaddedContainer = "_lq-b";
export var emailHeader = "_lq-6";
export var emailIframe = "_lq-3";
export var emailInfoIcon = "_lq-9";
export var emailShortenedSummary = "_lq-e";
export var infoDropdown = "_lq-0";
export var infoRowBoundedContent = "_lq-d";
export var internal = "_lq-5";
export var merchant = "_lq-8";
export var messageInputContainer = "_lq-h";
export var normal = "_lq-7";
export var replyCard = "_lq-f";
export var subtleButton = "_lq-1";
export var subtleButtonIconContainer = "_lq-2";
export var toggleViewRepliesButton = "_lq-c";
export var wrappingText = "_lq-g";